import AccountRepository from '@/shared/http/repositories/access/account'
import AuthRepository from '@/shared/http/repositories/access/auth'
import { toast, loading } from '@/shared/utils/UIHelper'
import AuthService from '@/shared/services/auth'
import { JWTService } from '@/shared/services/jwt'
import * as mutation from './mutationTypes'
import { actionTypes as action } from './actionTypes'

export const actions = {
  async [action.SIGN_IN] ({ commit }, credentials) {
    return AuthService.signIn(credentials)
      .then((res) => {
        if (res.success) {
          commit(mutation.SET_JWT, JWTService.GetToken())
          return Promise.resolve({ success: true })
        }

        JWTService.DestroyToken()
        commit(mutation.SET_JWT, null)

        // return Promise.reject({ success: false })
        return Promise.reject(new Error('Not authorized'))
      })
      .catch(err => Promise.reject(err))
  },

  async [action.SIGN_SSO] ({ commit }, securityToken) {
    return AuthService.signSSO(securityToken)
      .then((res) => {
        if (res.success) {
          commit(mutation.SET_JWT, JWTService.GetToken())
          return Promise.resolve({ success: true })
        }

        JWTService.DestroyToken()
        commit(mutation.SET_JWT, null)

        return Promise.reject(new Error('Not authorized'))
      })
      .catch(err => Promise.reject(err))
  },

  /* eslint-disable-next-line */
  async [action.SIGN_OUT] ({ state, commit }, router) {
    await AuthService.signOut()
    state.userInfo = null
    commit(mutation.SET_USER_IS_LOGGED_IN, false)
    router.replace({ name: 'SignIn' }).catch(() => {})
  },

  [action.SET_USER_INFO] ({ state, commit }, data) {
    commit(mutation.SET_USER_INFO, data)
  },

  [action.FETCH_USER_INFO] ({ state, commit }, force) {
    if (process.env.NODE_ENV === 'development') {
      // Dev: comportamento original — JWTService + ContaID do payload
      if ((force || !state.userInfo) && JWTService.GetToken()) {
        loading.push()
        AccountRepository.Get(JWTService.GetTokenPayload().ContaID)
          .then((res) => {
            if (res.data.code === 200) {
              commit(mutation.SET_USER_INFO, res.data.data)
              commit(mutation.SET_USER_IS_LOGGED_IN, true)
              loading.pop()
              return
            }
            JWTService.DestroyToken()
            commit(mutation.SET_USER_IS_LOGGED_IN, false)
            toast.error('Sua sessão foi finalizada!')
            loading.pop()
          })
          .catch(() => {
            JWTService.DestroyToken()
            commit(mutation.SET_USER_IS_LOGGED_IN, false)
            toast.error('Acesso finalizado!')
            loading.pop()
          })
      }
    } else {
      // Prod/aceite: chamar /me com cookie (sem JWTService)
      if (force || !state.userInfo) {
        loading.push()
        return AuthRepository.Me()
          .then((res) => {
            if (res.data.code === 200) {
              commit(mutation.SET_USER_IS_LOGGED_IN, true)
              // Buscar dados completos do usuário via ContaID retornado pelo /me
              return AccountRepository.Get(res.data.data.contaID)
                .then((userRes) => {
                  if (userRes.data.code === 200) {
                    commit(mutation.SET_USER_INFO, userRes.data.data)
                  }
                  loading.pop()
                })
                .catch(() => { loading.pop() })
            }
            commit(mutation.SET_USER_IS_LOGGED_IN, false)
            loading.pop()
          })
          .catch(() => {
            commit(mutation.SET_USER_IS_LOGGED_IN, false)
            loading.pop()
          })
      }
    }
  }

}

export default actions



// WEBPACK FOOTER //
// ./src/store/module/auth/actions.js